import "./InputCheckbox.scss";
import PropTypes from "prop-types";
import _ from "lodash";
import { FormattedMessage } from "react-intl";
import { useEffect, useState } from "react";
import { normalizeCheckboxValues } from "utils/balancesheetHelper";

const InputCheckbox = ({
  label,
  isInline,
  options,
  id,
  getSelectedValue,
  value,
  readOnly,
}) => {
  const [values, setValues] = useState(value || []);

  useEffect(() => setValues(normalizeCheckboxValues(value)), [value]);

  return (
    <div className="checkboxes" id={id}>
      <div
        className={
          isInline ? "checkboxes__row__inline" : "checkboxes__row__column"
        }
      >
        {options.map((elm) => (
          <div className="checkboxes__item" key={elm?.val}>
            <label
              className="checkbox style-c"
              style={{ cursor: readOnly ? "unset" : "pointer" }}
            >
              <input
                type="checkbox"
                value={elm?.val}
                onChange={(e) => {
                  if (!readOnly) {
                    const normalizedValue = e.target.value;
                    const updatedValues = e?.target?.checked
                      ? _.chain(values)
                          .push(normalizedValue)
                          .uniqWith(_.isEqual)
                          .value()
                      : _.chain(values)
                          .filter((item) => item !== normalizedValue)
                          .value();

                    setValues(updatedValues);
                    getSelectedValue(updatedValues);
                  }
                }}
                checked={_.includes(values, String(elm?.val))}
              />
              <div className="checkbox__checkmark"></div>
              <div className="checkbox__body"> {elm?.clb || elm?.lb}</div>
            </label>
          </div>
        ))}
      </div>
      {label && (
        <div className="input-checkbox-label">
          {typeof label === "string" ? label : <FormattedMessage {...label} />}
        </div>
      )}
    </div>
  );
};

InputCheckbox.propTypes = {
  label: PropTypes.any,
  isInline: PropTypes.bool,
  options: PropTypes.array,
  id: PropTypes.any,
  getSelectedValue: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
};
InputCheckbox.defaultProps = {
  label: "",
  isInline: true,
  options: [],
  defaultValue: null,
  id: "",
};
export default InputCheckbox;
